export default __webpack_public_path__ + "static/media/photo--sm--blitz-4.a9abbf61.jpg";